"use client";

import React, { useEffect } from "react";
import {
  Dialog,
  Box,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faTimes } from "@fortawesome/free-solid-svg-icons";
import "./modal.scss";
import { VeBox, VeTypography } from "../../mui";
import { VeButton } from "..";
interface InputModalProps {
  children?: React.ReactNode;
  title?: string | React.ReactNode;
  goBack?: boolean;
  desc?: string;
  loading?: boolean;
  icon?: React.ReactNode;
  handleGoBack?: () => void;
  outlinedButtonTitle?: string;
  disableContainedButton?: boolean;
  containedButtonTitle?: string;
  containedOnClick?: any;
  outlinedOnClick?: () => void;
  onSubmit?: (e?: any) => void;
  width?: string;
  open: boolean; // Determine if modal is open or closed
  onClose?: () => void; // Function to handle modal close
  containedButtonBelowDetails?: React.ReactNode;
  singleContainedButton?: boolean;
  paddingBottomReduce?: number;
  TransitionComponent?: any;
  containedButtonType?: any;
  minWidth?: any;
  iconAboveTitle?: any;
  sx?: any;
  dialogueSx?: any;
  lightbackDrop?: boolean;
  buttonsOnEnd?: boolean;
  titleStart?: boolean;
  titleIcon?: any;
  titleIconOnClick?: any;
  leftAlign?: any;
  descStart?: boolean;
}
// const useStyles = makeStyles({
//   hover: {
//     "&:hover": { background: "#F3F3F3", borderRadius: "100%" },
//     // marginTop: 15,
//   },
//   modal: {
//     "& .MuiPaper-rounded": {
//       borderRadius: "8px !important",
//       // overflow: "visible", // REMOVE THIS IF ANY MODAL BREAKS
//     },
//   },
// });

const useStyles = makeStyles((theme) => ({
  hover: {
    "&:hover": {
      background: "#F3F3F3",
      borderRadius: "100%",
    },
    // marginTop: 15,
  },
  modal: (props: any) => ({
    "& .MuiPaper-rounded": {
      borderRadius: "8px !important",
      overflow: props.lightbackDrop ? "visible" : "none", // REMOVE THIS IF ANY MODAL BREAKS
    },
  }),
}));

export function InputModal({
  children,
  title,
  goBack,
  desc,
  icon,
  loading,
  handleGoBack,
  outlinedButtonTitle,
  disableContainedButton,
  containedButtonTitle,
  containedOnClick,
  outlinedOnClick,
  width = "436px",
  open,
  onClose,
  onSubmit,
  containedButtonBelowDetails,
  singleContainedButton,
  paddingBottomReduce,
  TransitionComponent,
  containedButtonType = "submit",
  iconAboveTitle,
  minWidth,
  sx,
  dialogueSx,
  lightbackDrop = false,
  buttonsOnEnd = false,
  titleStart = false, // New prop to determine title alignment
  titleIconOnClick,
  titleIcon,
  leftAlign,
  descStart = false,
}: InputModalProps) {
  const classes = useStyles({ lightbackDrop });

useEffect(() => {
  if (open) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }

  return () => {
    document.body.style.overflow = "";
  };
}, [open]);

  // const isLargeScreen = useMediaQuery("(min-width:1534px)");

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={TransitionComponent}
      className={`${classes.modal} no-overflow-bar`}
      hideBackdrop={false}
      aria-labelledby="responsive-dialog-title"
      sx={{ overflow: "scroll !important", ...dialogueSx }}
      PaperProps={{
        sx: {
          ...sx,
          boxShadow:
            "0px 2px 4px -1px rgba(0, 0, 0, 0.06), 0px 4px 6px -1px rgba(0, 0, 0, 0.1) !important",
          // marginTop: lightbackDrop && isLargeScreen ? "-350px" : "none",
          // overflow: lightbackDrop ? "none" : "scroll !important",
          MsOverflowStyle: "none" /* Internet Explorer 10+ */,
          scrollbarWidth: "none" /* Firefox */,
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: lightbackDrop
              ? "rgba(232, 232, 232, 0.9)"
              : "rgba(0, 0, 0, 0.5)",
          },
        },
      }}
    >
      <form onSubmit={onSubmit}>
        <Box
          maxWidth={width}
          minWidth={minWidth}
          sx={{ padding: "16px 16px 24px 16px" }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              paddingBottom:
                paddingBottomReduce || paddingBottomReduce === 0
                  ? `${paddingBottomReduce}px`
                  : "1.5rem",
            }}
          >
            {goBack && (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box onClick={handleGoBack} style={{ cursor: "pointer" }}>
                  <FontAwesomeIcon
                    width="22px"
                    height="22px"
                    icon={faChevronLeft}
                    style={{ marginRight: "8px" }}
                  />
                </Box>
              </Box>
            )}
            <Box
              display="flex"
              justifyContent={"center"}
              sx={{ alignItems: "center" }}
              flexDirection={"column"}
              gap="6px"
              // pb="1.5rem"
              marginRight={leftAlign ? "none" : "auto"}
              marginLeft={titleStart || goBack || leftAlign ? "none" : "auto"}
            >
              {iconAboveTitle && (
                <Box
                  display="flex"
                  justifyContent="center"
                  sx={{ alignItems: "center" }}
                >
                  <Box sx={{ textAlign: "center" }}>{iconAboveTitle}</Box>
                </Box>
              )}
              {title && (
                <VeBox
                  display="flex"
                  flexDirection="row"
                  gap="12px"
                  alignItems="center"
                >
                  <VeTypography
                    variant="subtitle2StrongerMain"
                    align="center"
                    p={0}
                  >
                    {title}
                  </VeTypography>
                  {titleIcon && (
                    <VeBox
                      display="flex"
                      alignItems="center"
                      onClick={titleIconOnClick}
                    >
                      {titleIcon}
                    </VeBox>
                  )}
                </VeBox>
              )}
            </Box>
            {onClose ? (
              <Box
                onClick={onClose}
                sx={{
                  cursor: "pointer",
                  // marginLeft: "auto",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <CloseIcon />
              </Box>
            ) : (
              <div />
            )}
          </Box>
          <Box className="modal-div-gif">
            <Box>
              {icon && (
                <Box
                  display="flex"
                  justifyContent="center"
                  pb="1.5rem"
                  sx={{ alignItems: "center" }}
                >
                  <Box
                    width="6.25rem"
                    height="6.25rem"
                    sx={{ textAlign: "center" }}
                  >
                    {icon}
                  </Box>
                </Box>
              )}
              {desc && (
                <Box
                  display="flex"
                  justifyContent="center"
                  paddingBottom="1.5rem"
                  sx={{ alignItems: descStart ? "flex-start" : "center" }}
                >
                  <Typography
                    variant="body1"
                    align={descStart ? "left" : "center"}
                    p={0}
                  >
                    {desc}
                  </Typography>
                </Box>
              )}
              <Box>
                <Box
                  paddingBottom={
                    (outlinedButtonTitle && "1.5rem") ||
                    (containedButtonTitle && "1.5rem")
                  }
                  // paddingTop="16px"
                  display="flex"
                  justifyContent="center"
                  sx={{ lineHeight: "0" }}
                >
                  <Box width={minWidth ? minWidth : "436px"}> {children}</Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: singleContainedButton
                      ? "center"
                      : buttonsOnEnd
                        ? "end"
                        : "space-between",
                  }}
                >
                  <>
                    {outlinedButtonTitle && (
                      <Box
                        // paddingRight="8px"
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: buttonsOnEnd ? "25%" : "50%",
                          "@media screen and (max-width:400px)": {
                            width: "30%",
                          },
                        }}
                      >
                        {/* <VeButton
                          buttonVariant="outlined"
                          color="primary"
                          buttonFullWidth
                          buttonClick={outlinedOnClick}
                          type="button"
                          styles={{ height: buttonsOnEnd ? "36px" : "auto" }}
                        >
                          {outlinedButtonTitle}
                        </VeButton> */}
                        <VeBox
                          onClick={outlinedOnClick}
                          className="link"
                          display={"flex"}
                          alignItems={"center"}
                          justifyContent={"center"}
                        >
                          <VeTypography variant="label3StrongBrand">
                            {outlinedButtonTitle}
                          </VeTypography>
                        </VeBox>
                      </Box>
                    )}
                    {containedButtonTitle && (
                      <Box
                        // paddingLeft={outlinedButtonTitle ? "8px" : ""}
                        sx={{
                          width: buttonsOnEnd
                            ? "25%"
                            : !outlinedButtonTitle
                              ? singleContainedButton
                                ? "25%"
                                : "100%"
                              : "50%",
                          display:
                            singleContainedButton || buttonsOnEnd ? "flex" : "",
                          justifyContent: singleContainedButton ? "center" : "",
                          "@media screen and (max-width:400px)": {
                            width: "30%",
                          },
                        }}
                      >
                        <VeButton
                          buttonVariant="contained"
                          color="primary"
                          buttonFullWidth
                          loading={loading}
                          buttonClick={(e: any) => {
                            if (containedOnClick) {
                              e.preventDefault();
                              containedOnClick();
                            } else return;
                          }}
                          buttonMinWidth="96px"
                          size="small"
                          disabled={disableContainedButton}
                          type={containedButtonType}
                          styles={{ height: buttonsOnEnd ? "36px" : "36px" }}
                        >
                          {containedButtonTitle}
                        </VeButton>
                      </Box>
                    )}
                  </>
                </Box>
              </Box>
              {containedButtonBelowDetails && (
                <VeBox marginTop="24px" display="flex" justifyContent="center">
                  {containedButtonBelowDetails}
                </VeBox>
              )}
            </Box>{" "}
          </Box>
        </Box>
      </form>
    </Dialog>
  );
}

export const CloseIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.295 2.115C13.6844 1.72564 13.6844 1.09436 13.295 0.705C12.9056 0.315639 12.2744 0.315639 11.885 0.705L7 5.59L2.115 0.705C1.72564 0.315639 1.09436 0.315639 0.705 0.705C0.315639 1.09436 0.315639 1.72564 0.705 2.115L5.59 7L0.705 11.885C0.315639 12.2744 0.315639 12.9056 0.705 13.295C1.09436 13.6844 1.72564 13.6844 2.115 13.295L7 8.41L11.885 13.295C12.2744 13.6844 12.9056 13.6844 13.295 13.295C13.6844 12.9056 13.6844 12.2744 13.295 11.885L8.41 7L13.295 2.115Z"
        fill="#5F6368"
        width="14"
        height="14"
      />
    </svg>
  );
};
